var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.989 14.0139C24.989 19.4956 21.0094 24.6298 15.5726 26.132C15.2026 26.2329 14.799 26.2329 14.4291 26.132C8.99225 24.6298 5.0127 19.4956 5.0127 14.0139V9.09272C5.0127 8.1735 5.70773 7.13097 6.5709 6.78346L12.8149 4.22761C14.2161 3.6559 15.7967 3.6559 17.198 4.22761L23.442 6.78346C24.2939 7.13097 25.0002 8.1735 25.0002 9.09272L24.989 14.0139Z",
    stroke: "currentColor",
    strokeWidth: 1.3452,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0008 15.5607C16.239 15.5607 17.2428 14.5569 17.2428 13.3187C17.2428 12.0804 16.239 11.0767 15.0008 11.0767C13.7626 11.0767 12.7588 12.0804 12.7588 13.3187C12.7588 14.5569 13.7626 15.5607 15.0008 15.5607Z",
    stroke: "currentColor",
    strokeWidth: 1.3452,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 15.5605V18.9236",
    stroke: "currentColor",
    strokeWidth: 1.3452,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPin);
export default __webpack_public_path__ + "static/media/reset_pin.352f91e8.svg";
export { ForwardRef as ReactComponent };